<div id="app-sidebar" class="layout-sidebar">
    <div class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>
